// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledVisits-module__font-s-10___GQomg {
  font-size: 10px !important;
}

.ScheduledVisits-module__font-s-12___yFhCI {
  font-size: 12px !important;
}

.ScheduledVisits-module__font-s-13___ou02P {
  font-size: 13px !important;
}

.ScheduledVisits-module__font-s-14___v0Avj {
  font-size: 14px !important;
}

.ScheduledVisits-module__font-s-15___FBUXc {
  font-size: 15px !important;
}

.ScheduledVisits-module__font-s-16___Y97k5 {
  font-size: 16px !important;
}

.ScheduledVisits-module__font-s-18___gZdYx {
  font-size: 18px !important;
}

.ScheduledVisits-module__font-s-20___wkPyW {
  font-size: 20px !important;
}

.ScheduledVisits-module__font-s-22___xYxlW {
  font-size: 22px !important;
}

.ScheduledVisits-module__font-s-28___A6l0u {
  font-size: 28px !important;
}

.ScheduledVisits-module__font-w-400___gSyhx {
  font-weight: 400 !important;
}

.ScheduledVisits-module__font-w-500___YAFqI {
  font-weight: 500 !important;
}

.ScheduledVisits-module__font-w-600___dhACR {
  font-weight: 600 !important;
}

.ScheduledVisits-module__font-w-700____ES9m {
  font-weight: 700 !important;
}

.ScheduledVisits-module__p-5___jThH8 {
  padding: 5px !important;
}

.ScheduledVisits-module__p-12___vh2gf {
  padding: 12px !important;
}

.ScheduledVisits-module__p-16___FpypC {
  padding: 16px !important;
}

.ScheduledVisits-module__p-30___k10gV {
  padding: 30px !important;
}

.ScheduledVisits-module__p-b-0___OH0qW {
  padding-bottom: 0 !important;
}

.ScheduledVisits-module__p-b-5____n4c1 {
  padding-bottom: 5px !important;
}

.ScheduledVisits-module__p-b-10____7kj_ {
  padding-bottom: 10px !important;
}

.ScheduledVisits-module__p-b-12___PbrLM {
  padding-bottom: 12px !important;
}

.ScheduledVisits-module__p-b-16___i1cg3 {
  padding-bottom: 16px !important;
}

.ScheduledVisits-module__p-b-18___Ffwo4 {
  padding-bottom: 18px !important;
}

.ScheduledVisits-module__p-b-20___Ec3AD {
  padding-bottom: 20px !important;
}

.ScheduledVisits-module__p-b-25___hnLw1 {
  padding-bottom: 25px !important;
}

.ScheduledVisits-module__p-b-30___Khtti {
  padding-bottom: 30px !important;
}

.ScheduledVisits-module__p-b-50___Z_zy_ {
  padding-bottom: 50px !important;
}

.ScheduledVisits-module__p-t-0___mK8Z5 {
  padding-top: 0 !important;
}

.ScheduledVisits-module__p-t-12___JFq3o {
  padding-top: 12px !important;
}

.ScheduledVisits-module__p-t-16___PU6NV {
  padding-top: 16px !important;
}

.ScheduledVisits-module__p-t-18___JdAYV {
  padding-top: 18px !important;
}

.ScheduledVisits-module__p-t-20___zMXnB {
  padding-top: 20px !important;
}

.ScheduledVisits-module__p-t-30___vQXj7 {
  padding-top: 30px !important;
}

.ScheduledVisits-module__p-t-40___MbWRR {
  padding-top: 40px !important;
}

.ScheduledVisits-module__p-t-50___WpRYY {
  padding-top: 50px !important;
}

.ScheduledVisits-module__p-l-20___FxQgV {
  padding-left: 20px !important;
}

.ScheduledVisits-module__p-l-30___gqkIf {
  padding-left: 30px !important;
}

.ScheduledVisits-module__p-l-40___mMriZ {
  padding-left: 40px !important;
}

.ScheduledVisits-module__p-r-16___RQzXJ {
  padding-right: 16px !important;
}

.ScheduledVisits-module__p-r-20___qbyzN {
  padding-right: 20px !important;
}

.ScheduledVisits-module__p-r-30___zYMkA {
  padding-right: 30px !important;
}

.ScheduledVisits-module__p-r-50___B6rqy {
  padding-right: 50px !important;
}

.ScheduledVisits-module__p-r-60___Bj7QJ {
  padding-right: 60px !important;
}

.ScheduledVisits-module__m-b-1___c0S6a {
  margin-bottom: 1px !important;
}

.ScheduledVisits-module__m-b-2___S2UHO {
  margin-bottom: 2px !important;
}

.ScheduledVisits-module__m-b-6___Z9fye {
  margin-bottom: 6px !important;
}

.ScheduledVisits-module__m-b-8____2smy {
  margin-bottom: 8px !important;
}

.ScheduledVisits-module__m-b-10___omV0o {
  margin-bottom: 10px !important;
}

.ScheduledVisits-module__m-b-14___nnrAE {
  margin-bottom: 14px !important;
}

.ScheduledVisits-module__m-b-16___sxZIX {
  margin-bottom: 16px !important;
}

.ScheduledVisits-module__m-b-20___RObm9 {
  margin-bottom: 20px !important;
}

.ScheduledVisits-module__m-b-22___abiZ8 {
  margin-bottom: 22px !important;
}

.ScheduledVisits-module__m-b-24___sCAg_ {
  margin-bottom: 24px !important;
}

.ScheduledVisits-module__m-b-30___z739q {
  margin-bottom: 30px !important;
}

.ScheduledVisits-module__m-b-32___qLQsz {
  margin-bottom: 32px !important;
}

.ScheduledVisits-module__m-b-40___wIrw3 {
  margin-bottom: 40px !important;
}

.ScheduledVisits-module__m-t-2___rBs58 {
  margin-top: 2px !important;
}

.ScheduledVisits-module__m-t-3___LPhkQ {
  margin-top: 3px !important;
}

.ScheduledVisits-module__m-t-4___AjMul {
  margin-top: 4px !important;
}

.ScheduledVisits-module__m-t-5___WwaBd {
  margin-top: 5px !important;
}

.ScheduledVisits-module__m-t-8___odhzi {
  margin-top: 8px !important;
}

.ScheduledVisits-module__m-t-10___Jtg57 {
  margin-top: 10px !important;
}

.ScheduledVisits-module__m-t-15___TwAXd {
  margin-top: 15px !important;
}

.ScheduledVisits-module__m-t-16___pGzBB {
  margin-top: 16px !important;
}

.ScheduledVisits-module__m-t-20___n1nBm {
  margin-top: 20px !important;
}

.ScheduledVisits-module__m-t-22___Svfrq {
  margin-top: 22px !important;
}

.ScheduledVisits-module__m-t-30___c0sln {
  margin-top: 30px !important;
}

.ScheduledVisits-module__m-t-32___y7lnq {
  margin-top: 32px !important;
}

.ScheduledVisits-module__m-l-auto___X85bA {
  margin-left: auto !important;
}

.ScheduledVisits-module__m-l-4___zzT6X {
  margin-left: 4px !important;
}

.ScheduledVisits-module__m-l-5___FrsS0 {
  margin-left: 5px !important;
}

.ScheduledVisits-module__m-l-6___wttcq {
  margin-left: 6px !important;
}

.ScheduledVisits-module__m-l-8___DCnPL {
  margin-left: 8px !important;
}

.ScheduledVisits-module__m-l-10___lnLNI {
  margin-left: 10px !important;
}

.ScheduledVisits-module__m-l-16___kYKVX {
  margin-left: 16px !important;
}

.ScheduledVisits-module__m-l-20___NvoWG {
  margin-left: 20px !important;
}

.ScheduledVisits-module__m-l-24___ZjJac {
  margin-left: 24px !important;
}

.ScheduledVisits-module__m-l-30___X94L7 {
  margin-left: 30px !important;
}

.ScheduledVisits-module__m-l-35___Rghaw {
  margin-left: 35px !important;
}

.ScheduledVisits-module__m-l-40___Ct4YQ {
  margin-left: 40px !important;
}

.ScheduledVisits-module__m-r-8___uqAsf {
  margin-right: 8px !important;
}

.ScheduledVisits-module__m-r-10___o7V9p {
  margin-right: 10px !important;
}

.ScheduledVisits-module__m-r-16___uxya2 {
  margin-right: 16px !important;
}

.ScheduledVisits-module__m-r-20___kWYQK {
  margin-right: 20px !important;
}

.ScheduledVisits-module__m-r-24___G2MYa {
  margin-right: 24px !important;
}

.ScheduledVisits-module__m-r-30___O87CF {
  margin-right: 30px !important;
}

.ScheduledVisits-module__m-r-40___Il61_ {
  margin-right: 40px !important;
}

.ScheduledVisits-module__border-r-3___uyHTV {
  border-radius: 3px !important;
}

.ScheduledVisits-module__border-r-4___xNg64 {
  border-radius: 4px !important;
}

.ScheduledVisits-module__border-r-6___zyVI_ {
  border-radius: 6px !important;
}

.ScheduledVisits-module__border-r-10___ICu2l {
  border-radius: 10px !important;
}

.ScheduledVisits-module__border-r-12___LoONc {
  border-radius: 12px !important;
}

.ScheduledVisits-module__border-r-16___haUHC {
  border-radius: 16px !important;
}

.ScheduledVisits-module__border-r-50___a0Dd8 {
  border-radius: 50% !important;
}

.ScheduledVisits-module__primary-border___wHfXs {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisits-module__primary-border-b___U0rbf {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisits-module__primary-border-t___Gnqwg {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisits-module__primary-border-l___oLK3s {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisits-module__primary-border-r___HDhQb {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ScheduledVisits-module__secondary-border___oLOuz {
  border: 1px solid #637768;
}

.ScheduledVisits-module__secondary-border-b___ER9ys {
  border-bottom: 1px solid #637768;
}

.ScheduledVisits-module__secondary-border-t___pmct1 {
  border-top: 1px solid #637768;
}

.ScheduledVisits-module__secondary-border-l___MT5PX {
  border-left: 1px solid #637768;
}

.ScheduledVisits-module__secondary-border-r___AozuT {
  border-right: 1px solid #637768;
}

.ScheduledVisits-module__gap-0___SErW6 {
  gap: 0 !important;
}

.ScheduledVisits-module__gap-2___OBJjI {
  gap: 2px !important;
}

.ScheduledVisits-module__gap-4___QD3sK {
  gap: 4px !important;
}

.ScheduledVisits-module__gap-5___OD7oB {
  gap: 5px !important;
}

.ScheduledVisits-module__gap-6___mBf25 {
  gap: 6px !important;
}

.ScheduledVisits-module__gap-8___oQiVh {
  gap: 8px !important;
}

.ScheduledVisits-module__gap-10___Yj6ST {
  gap: 10px !important;
}

.ScheduledVisits-module__gap-12___oAD7m {
  gap: 12px !important;
}

.ScheduledVisits-module__gap-14___DWl8L {
  gap: 14px !important;
}

.ScheduledVisits-module__gap-16___Kw0Nd {
  gap: 16px !important;
}

.ScheduledVisits-module__gap-18___ZRRZt {
  gap: 18px !important;
}

.ScheduledVisits-module__gap-20___Lwf53 {
  gap: 20px !important;
}

.ScheduledVisits-module__gap-24___jydrI {
  gap: 24px !important;
}

.ScheduledVisits-module__gap-26___MWXRy {
  gap: 26px !important;
}

.ScheduledVisits-module__gap-30___sC4hk {
  gap: 30px !important;
}

.ScheduledVisits-module__gap-32___Zaa6B {
  gap: 32px !important;
}

.ScheduledVisits-module__gap-40___MH332 {
  gap: 40px !important;
}

.ScheduledVisits-module__gap-50___ZcJQV {
  gap: 50px !important;
}

.ScheduledVisits-module__flex-1___v3FAe {
  flex: 1;
}

.ScheduledVisits-module__flex-none___jbvhp {
  flex: none !important;
}

.ScheduledVisits-module__flex-column___PWkEw {
  display: flex;
  flex-direction: column !important;
}

.ScheduledVisits-module__flex-row___a7gru {
  display: flex;
  flex-direction: row !important;
}

.ScheduledVisits-module__vertically-centered___WxgF4 {
  display: flex;
  align-items: center !important;
}

.ScheduledVisits-module__horizontally-centered___hKRfT {
  display: flex;
  justify-content: center !important;
}

.ScheduledVisits-module__horizontally-end___Zw7sZ {
  display: flex;
  justify-content: end !important;
}

.ScheduledVisits-module__vertically-start___IsBFs {
  display: flex;
  align-items: start !important;
}

.ScheduledVisits-module__space-between___JPMbF {
  display: flex;
  justify-content: space-between !important;
}

.ScheduledVisits-module__flex-wrap___KrmN9 {
  flex-wrap: wrap !important;
}

.ScheduledVisits-module__height-100___NrGBu {
  height: 100%;
}

.ScheduledVisits-module__width-50___lFYrj {
  width: 50% !important;
}

.ScheduledVisits-module__width-100___oJnht {
  width: 100%;
}

.ScheduledVisits-module__cursor-pointer___erR4M {
  cursor: pointer;
}

.ScheduledVisits-module__cursor-not-allowed___dRXEX {
  cursor: not-allowed !important;
}

.ScheduledVisits-module__absolute-centered___Xg6YM {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ScheduledVisits-module__absolute___A9aky {
  position: absolute;
}

.ScheduledVisits-module__relative___9ZTXA {
  position: relative;
}

.ScheduledVisits-module__fixed___UxJ7e {
  position: fixed;
}

.ScheduledVisits-module__visible___ZvtiV {
  opacity: 1;
}

.ScheduledVisits-module__invisible___RbN6h {
  opacity: 0;
}

.ScheduledVisits-module__col-90___KG7jJ {
  width: 90% !important;
}

.ScheduledVisits-module__col-auto___HlcRt {
  width: auto !important;
}

.ScheduledVisits-module__medical-tabs___MVN3p {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ScheduledVisits-module__medical-table-new___aed3n {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledVisits-module__medical-table-new___aed3n:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledVisits-module__medical-table-new___aed3n::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledVisits-module__medical-table-new___aed3n::-webkit-scrollbar-track {
  display: none;
}
.ScheduledVisits-module__medical-table-new___aed3n.ScheduledVisits-module__no-pagination___oCAnW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ScheduledVisits-module__medical-table-new___aed3n.ScheduledVisits-module__no-pagination___oCAnW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ScheduledVisits-module__medical-table-new___aed3n.ScheduledVisits-module__no-pagination___oCAnW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ScheduledVisits-module__medical-table-new___aed3n.ScheduledVisits-module__no-pagination___oCAnW::-webkit-scrollbar-track {
  display: none;
}

.ScheduledVisits-module__medical-table-empty___wQ3XQ {
  padding: 14px 40px !important;
}

.ScheduledVisits-module__icon-btn___CBAQ4 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ScheduledVisits-module__search-icon___nfArn {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ScheduledVisits-module__disable-select___qsjw8 {
  user-select: none;
}

.ScheduledVisits-module__break-word___pe34r {
  word-break: break-word;
}

.ScheduledVisits-module__popup-clear-btn___y0hXR {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ScheduledVisits-module__scroll-m-b-20___jUv2j {
  scroll-margin-bottom: 20px;
}

.ScheduledVisits-module__header___jjuHD {
  color: #375844;
}

.ScheduledVisits-module__checkbox___D0WmV > div {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/LinkedVsitsModule/ScheduledVisits/ScheduledVisits.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA1pBE;EACE,0BAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  color: get-color(greenNew, dark);\n}\n\n.checkbox {\n  & > div {\n    font-size: 12px !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ScheduledVisits-module__font-s-10___GQomg`,
	"fontS12": `ScheduledVisits-module__font-s-12___yFhCI`,
	"fontS13": `ScheduledVisits-module__font-s-13___ou02P`,
	"fontS14": `ScheduledVisits-module__font-s-14___v0Avj`,
	"fontS15": `ScheduledVisits-module__font-s-15___FBUXc`,
	"fontS16": `ScheduledVisits-module__font-s-16___Y97k5`,
	"fontS18": `ScheduledVisits-module__font-s-18___gZdYx`,
	"fontS20": `ScheduledVisits-module__font-s-20___wkPyW`,
	"fontS22": `ScheduledVisits-module__font-s-22___xYxlW`,
	"fontS28": `ScheduledVisits-module__font-s-28___A6l0u`,
	"fontW400": `ScheduledVisits-module__font-w-400___gSyhx`,
	"fontW500": `ScheduledVisits-module__font-w-500___YAFqI`,
	"fontW600": `ScheduledVisits-module__font-w-600___dhACR`,
	"fontW700": `ScheduledVisits-module__font-w-700____ES9m`,
	"p5": `ScheduledVisits-module__p-5___jThH8`,
	"p12": `ScheduledVisits-module__p-12___vh2gf`,
	"p16": `ScheduledVisits-module__p-16___FpypC`,
	"p30": `ScheduledVisits-module__p-30___k10gV`,
	"pB0": `ScheduledVisits-module__p-b-0___OH0qW`,
	"pB5": `ScheduledVisits-module__p-b-5____n4c1`,
	"pB10": `ScheduledVisits-module__p-b-10____7kj_`,
	"pB12": `ScheduledVisits-module__p-b-12___PbrLM`,
	"pB16": `ScheduledVisits-module__p-b-16___i1cg3`,
	"pB18": `ScheduledVisits-module__p-b-18___Ffwo4`,
	"pB20": `ScheduledVisits-module__p-b-20___Ec3AD`,
	"pB25": `ScheduledVisits-module__p-b-25___hnLw1`,
	"pB30": `ScheduledVisits-module__p-b-30___Khtti`,
	"pB50": `ScheduledVisits-module__p-b-50___Z_zy_`,
	"pT0": `ScheduledVisits-module__p-t-0___mK8Z5`,
	"pT12": `ScheduledVisits-module__p-t-12___JFq3o`,
	"pT16": `ScheduledVisits-module__p-t-16___PU6NV`,
	"pT18": `ScheduledVisits-module__p-t-18___JdAYV`,
	"pT20": `ScheduledVisits-module__p-t-20___zMXnB`,
	"pT30": `ScheduledVisits-module__p-t-30___vQXj7`,
	"pT40": `ScheduledVisits-module__p-t-40___MbWRR`,
	"pT50": `ScheduledVisits-module__p-t-50___WpRYY`,
	"pL20": `ScheduledVisits-module__p-l-20___FxQgV`,
	"pL30": `ScheduledVisits-module__p-l-30___gqkIf`,
	"pL40": `ScheduledVisits-module__p-l-40___mMriZ`,
	"pR16": `ScheduledVisits-module__p-r-16___RQzXJ`,
	"pR20": `ScheduledVisits-module__p-r-20___qbyzN`,
	"pR30": `ScheduledVisits-module__p-r-30___zYMkA`,
	"pR50": `ScheduledVisits-module__p-r-50___B6rqy`,
	"pR60": `ScheduledVisits-module__p-r-60___Bj7QJ`,
	"mB1": `ScheduledVisits-module__m-b-1___c0S6a`,
	"mB2": `ScheduledVisits-module__m-b-2___S2UHO`,
	"mB6": `ScheduledVisits-module__m-b-6___Z9fye`,
	"mB8": `ScheduledVisits-module__m-b-8____2smy`,
	"mB10": `ScheduledVisits-module__m-b-10___omV0o`,
	"mB14": `ScheduledVisits-module__m-b-14___nnrAE`,
	"mB16": `ScheduledVisits-module__m-b-16___sxZIX`,
	"mB20": `ScheduledVisits-module__m-b-20___RObm9`,
	"mB22": `ScheduledVisits-module__m-b-22___abiZ8`,
	"mB24": `ScheduledVisits-module__m-b-24___sCAg_`,
	"mB30": `ScheduledVisits-module__m-b-30___z739q`,
	"mB32": `ScheduledVisits-module__m-b-32___qLQsz`,
	"mB40": `ScheduledVisits-module__m-b-40___wIrw3`,
	"mT2": `ScheduledVisits-module__m-t-2___rBs58`,
	"mT3": `ScheduledVisits-module__m-t-3___LPhkQ`,
	"mT4": `ScheduledVisits-module__m-t-4___AjMul`,
	"mT5": `ScheduledVisits-module__m-t-5___WwaBd`,
	"mT8": `ScheduledVisits-module__m-t-8___odhzi`,
	"mT10": `ScheduledVisits-module__m-t-10___Jtg57`,
	"mT15": `ScheduledVisits-module__m-t-15___TwAXd`,
	"mT16": `ScheduledVisits-module__m-t-16___pGzBB`,
	"mT20": `ScheduledVisits-module__m-t-20___n1nBm`,
	"mT22": `ScheduledVisits-module__m-t-22___Svfrq`,
	"mT30": `ScheduledVisits-module__m-t-30___c0sln`,
	"mT32": `ScheduledVisits-module__m-t-32___y7lnq`,
	"mLAuto": `ScheduledVisits-module__m-l-auto___X85bA`,
	"mL4": `ScheduledVisits-module__m-l-4___zzT6X`,
	"mL5": `ScheduledVisits-module__m-l-5___FrsS0`,
	"mL6": `ScheduledVisits-module__m-l-6___wttcq`,
	"mL8": `ScheduledVisits-module__m-l-8___DCnPL`,
	"mL10": `ScheduledVisits-module__m-l-10___lnLNI`,
	"mL16": `ScheduledVisits-module__m-l-16___kYKVX`,
	"mL20": `ScheduledVisits-module__m-l-20___NvoWG`,
	"mL24": `ScheduledVisits-module__m-l-24___ZjJac`,
	"mL30": `ScheduledVisits-module__m-l-30___X94L7`,
	"mL35": `ScheduledVisits-module__m-l-35___Rghaw`,
	"mL40": `ScheduledVisits-module__m-l-40___Ct4YQ`,
	"mR8": `ScheduledVisits-module__m-r-8___uqAsf`,
	"mR10": `ScheduledVisits-module__m-r-10___o7V9p`,
	"mR16": `ScheduledVisits-module__m-r-16___uxya2`,
	"mR20": `ScheduledVisits-module__m-r-20___kWYQK`,
	"mR24": `ScheduledVisits-module__m-r-24___G2MYa`,
	"mR30": `ScheduledVisits-module__m-r-30___O87CF`,
	"mR40": `ScheduledVisits-module__m-r-40___Il61_`,
	"borderR3": `ScheduledVisits-module__border-r-3___uyHTV`,
	"borderR4": `ScheduledVisits-module__border-r-4___xNg64`,
	"borderR6": `ScheduledVisits-module__border-r-6___zyVI_`,
	"borderR10": `ScheduledVisits-module__border-r-10___ICu2l`,
	"borderR12": `ScheduledVisits-module__border-r-12___LoONc`,
	"borderR16": `ScheduledVisits-module__border-r-16___haUHC`,
	"borderR50": `ScheduledVisits-module__border-r-50___a0Dd8`,
	"primaryBorder": `ScheduledVisits-module__primary-border___wHfXs`,
	"primaryBorderB": `ScheduledVisits-module__primary-border-b___U0rbf`,
	"primaryBorderT": `ScheduledVisits-module__primary-border-t___Gnqwg`,
	"primaryBorderL": `ScheduledVisits-module__primary-border-l___oLK3s`,
	"primaryBorderR": `ScheduledVisits-module__primary-border-r___HDhQb`,
	"secondaryBorder": `ScheduledVisits-module__secondary-border___oLOuz`,
	"secondaryBorderB": `ScheduledVisits-module__secondary-border-b___ER9ys`,
	"secondaryBorderT": `ScheduledVisits-module__secondary-border-t___pmct1`,
	"secondaryBorderL": `ScheduledVisits-module__secondary-border-l___MT5PX`,
	"secondaryBorderR": `ScheduledVisits-module__secondary-border-r___AozuT`,
	"gap0": `ScheduledVisits-module__gap-0___SErW6`,
	"gap2": `ScheduledVisits-module__gap-2___OBJjI`,
	"gap4": `ScheduledVisits-module__gap-4___QD3sK`,
	"gap5": `ScheduledVisits-module__gap-5___OD7oB`,
	"gap6": `ScheduledVisits-module__gap-6___mBf25`,
	"gap8": `ScheduledVisits-module__gap-8___oQiVh`,
	"gap10": `ScheduledVisits-module__gap-10___Yj6ST`,
	"gap12": `ScheduledVisits-module__gap-12___oAD7m`,
	"gap14": `ScheduledVisits-module__gap-14___DWl8L`,
	"gap16": `ScheduledVisits-module__gap-16___Kw0Nd`,
	"gap18": `ScheduledVisits-module__gap-18___ZRRZt`,
	"gap20": `ScheduledVisits-module__gap-20___Lwf53`,
	"gap24": `ScheduledVisits-module__gap-24___jydrI`,
	"gap26": `ScheduledVisits-module__gap-26___MWXRy`,
	"gap30": `ScheduledVisits-module__gap-30___sC4hk`,
	"gap32": `ScheduledVisits-module__gap-32___Zaa6B`,
	"gap40": `ScheduledVisits-module__gap-40___MH332`,
	"gap50": `ScheduledVisits-module__gap-50___ZcJQV`,
	"flex1": `ScheduledVisits-module__flex-1___v3FAe`,
	"flexNone": `ScheduledVisits-module__flex-none___jbvhp`,
	"flexColumn": `ScheduledVisits-module__flex-column___PWkEw`,
	"flexRow": `ScheduledVisits-module__flex-row___a7gru`,
	"verticallyCentered": `ScheduledVisits-module__vertically-centered___WxgF4`,
	"horizontallyCentered": `ScheduledVisits-module__horizontally-centered___hKRfT`,
	"horizontallyEnd": `ScheduledVisits-module__horizontally-end___Zw7sZ`,
	"verticallyStart": `ScheduledVisits-module__vertically-start___IsBFs`,
	"spaceBetween": `ScheduledVisits-module__space-between___JPMbF`,
	"flexWrap": `ScheduledVisits-module__flex-wrap___KrmN9`,
	"height100": `ScheduledVisits-module__height-100___NrGBu`,
	"width50": `ScheduledVisits-module__width-50___lFYrj`,
	"width100": `ScheduledVisits-module__width-100___oJnht`,
	"cursorPointer": `ScheduledVisits-module__cursor-pointer___erR4M`,
	"cursorNotAllowed": `ScheduledVisits-module__cursor-not-allowed___dRXEX`,
	"absoluteCentered": `ScheduledVisits-module__absolute-centered___Xg6YM`,
	"absolute": `ScheduledVisits-module__absolute___A9aky`,
	"relative": `ScheduledVisits-module__relative___9ZTXA`,
	"fixed": `ScheduledVisits-module__fixed___UxJ7e`,
	"visible": `ScheduledVisits-module__visible___ZvtiV`,
	"invisible": `ScheduledVisits-module__invisible___RbN6h`,
	"col90": `ScheduledVisits-module__col-90___KG7jJ`,
	"colAuto": `ScheduledVisits-module__col-auto___HlcRt`,
	"medicalTabs": `ScheduledVisits-module__medical-tabs___MVN3p`,
	"medicalTableNew": `ScheduledVisits-module__medical-table-new___aed3n`,
	"noPagination": `ScheduledVisits-module__no-pagination___oCAnW`,
	"medicalTableEmpty": `ScheduledVisits-module__medical-table-empty___wQ3XQ`,
	"iconBtn": `ScheduledVisits-module__icon-btn___CBAQ4`,
	"searchIcon": `ScheduledVisits-module__search-icon___nfArn`,
	"disableSelect": `ScheduledVisits-module__disable-select___qsjw8`,
	"breakWord": `ScheduledVisits-module__break-word___pe34r`,
	"popupClearBtn": `ScheduledVisits-module__popup-clear-btn___y0hXR`,
	"scrollMB20": `ScheduledVisits-module__scroll-m-b-20___jUv2j`,
	"header": `ScheduledVisits-module__header___jjuHD`,
	"checkbox": `ScheduledVisits-module__checkbox___D0WmV`
};
module.exports = ___CSS_LOADER_EXPORT___;
